module.exports = __webpack_public_path__ + "media/images/icons/tick-a72a6da793ab7d9d5953151b4b2931c5.svg";